import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import { PAYMENT_TARIFF } from '../../../types';
import locales from '../../../content.json';

/** @param {{ tariff?: string }} props */
export const PolycyBlockV2 = ({ tariff }) => {
  const vetOnboarding = useSelector(state => state.data.vetOnboarding);
  const nutritionOnboarding = useSelector(state => state.data.nutritionOnboarding);

  return (
    <p
      dangerouslySetInnerHTML={{
        __html: nutritionOnboarding
          ? locales[window.userLang].payment_text_351
          : vetOnboarding
          ? locales[window.userLang].payment_text_300
          : locales[window.userLang].payment_text_14_2,
      }}
      className={`${styles.polycyBlock} ${
        tariff === PAYMENT_TARIFF.V5 ||
        tariff === PAYMENT_TARIFF.V7 ||
        tariff === PAYMENT_TARIFF.V9 ||
        tariff === PAYMENT_TARIFF.V11 ||
        tariff === PAYMENT_TARIFF.V13 ||
        tariff === PAYMENT_TARIFF.V15 ||
        tariff === PAYMENT_TARIFF.V18 ||
        tariff === PAYMENT_TARIFF.V20 ||
        tariff === PAYMENT_TARIFF.V22 ||
        tariff === PAYMENT_TARIFF.V24 ||
        tariff === PAYMENT_TARIFF.V26 ||
        tariff === PAYMENT_TARIFF.V28 ||
        tariff === PAYMENT_TARIFF.V32 ||
        tariff === PAYMENT_TARIFF.V34 ||
        tariff === PAYMENT_TARIFF.V36 ||
        tariff === PAYMENT_TARIFF.V38 ||
        tariff === PAYMENT_TARIFF.V40 ||
        tariff === PAYMENT_TARIFF.V42 ||
        tariff === PAYMENT_TARIFF.V44 ||
        tariff === PAYMENT_TARIFF.V46
          ? styles.tariffV5
          : ''
      }`}
    />
  );
};
